export const ProposalCopyingForRecalConstant = {
    Title: {
        CATEGORY: "Recalculation",
        STANDARD_PROPOSAL_ITEM: "Standard Proposal Item",
        TITLE: "Proposal Copying for Recalculation",
        COPY_BUT: "Copy",
        RENEW_BUT: "Renew",
        DELETE_BUT: "Delete",
        SUBMIT_BUT: "Submit",
        UNCONFIRM_BUT: "Unconfirm",
        REJECT_BUT: "Reject",
        APPROVE_BUT: "Approve",
        REJECT_REASON: "Reject Reason",
        COPY_TO: "Copy To",
        COMPANY_CODE: "Company Code",
    },

    Table: {
        ALL_BUT: "All",
        FOR_RECAL_BUT: "Proposal For Recal",
        REJECTED_BUT: "Rejected",
        PENDING_APPROVAL_BUT: "Pending Approval",
        COMPANY_CODE: "Company Code",
        COPY_TO_COMPANY_CODE: "Copy To Company Code",
        PROPOSAL_NO: "Proposal No.",
        OPERATING_TML: "Operating Tml.",
        EFFECTIVE_DATE: "Effective Date",
        EFFECTIVE_DATE_RANGE: "Effective Date Range",
        EXPIRY_DATE: "Expiry Date",
        CURRENCY: "Currency",
        PROPOSAL_BY: "Proposal By",
        TARIFF_NATURE: "Tariff Nature",
        CONFIRMED_DATE: "Confirmed Date",
        STATUS: "Status",
        REJECT_REASON: "Reject Reason",
        REMARKS: "Remarks",
        //SEQ: "Seq",
        PRIORITY: "Priority",
        TARIFF_TYPE: "Tariff Type",
        TARIFF_CODE: "Tariff Code",
        FORWARDER_CODE: "Forwarder/Shipper/Consignee",
        MASTER: "Master",
        TARIFF_CODE_DESC: "Tariff Code Desc",
        TIER_NO: "TIER NO",
        CYCLE: "CYCLE",
        FOR_EVERY: "FOR EVERY",
        UOM: "UOM",
        RATE: "RATE",
        MINIMUM: "MINIMUM RATE",
        SURCHARGE: "SURCHARGE",
        SURCHARGE_TYPE: "SURCHARGE TYPE",
        ADDITIONAL_UOM: "ADDITIONAL UOM",
        ADDITIONAL_RATE: "ADDITIONAL RATE",
        SHIFT_CODE: "Shift Code",
        SURCHARGE_P: "Surcharge %",
        TIER_VALUE: "Tier",
        IS_VALUE: "IS",
        CHARGE_PERCENTAGE: "% Change",
        ROUND_METHOD: "Rounding Method",
        DECIMAL_PLACE: "Decimal Place",
        BUT_MASTER: "Master",
        BUT_ALLIANCE: "Alliance",
        BUT_GENERATE: "Generate",
        BUT_BACK: "Back",
    },

    Search: {
        SEARCH_CRITERIA: "Search Criteria",
        COMPANY_CODE: "Company Code",
        PROPOSAL_NO: "Proposal No.",
        OPERATING_TML: "Operating Tml.",
        STATUS: "Status",
        EFFECTIVE_DATE_RANGE: "Effective Date Range",
    }

}